// extracted by mini-css-extract-plugin
export default {"root":"FloatingLabelInput_root__b5NZH","label":"FloatingLabelInput_label__HvcV5","required":"FloatingLabelInput_required__2LHkn","input":"FloatingLabelInput_input__DOobe"};